<template>
    <div class="button-back-wrapper">
        <BaseButton slot="button" @click.native="goBack" title="Back"></BaseButton>
    </div>
  </template>

<script>
    export default {
        methods: {
            goBack() {
                window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
            }
        }
    }
</script>

<style lang="scss">
    .button-back-wrapper {
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/base/BaseButtonBack.vue